import { langFallback$Fetch } from '../../../lang/utils/langfetch'
import { SocialLoginResponse } from '../types'

interface Query {
  socialToken: string
  next?: string
}

type AuthType = 'facebook-web' | 'google-web'
interface Token {
  name: string
  value: string
}

async function getSocialLoginData(type: AuthType, token: Token, next?: string) {
  const postData = new FormData()
  postData.append(token.name, token.value)

  const baseUrl = `/social-jwt-login/${type}`
  const url = next ? `${baseUrl}?next=${encodeURIComponent(next)}` : baseUrl

  return await langFallback$Fetch<SocialLoginResponse>('en-gb', url, {
    method: 'POST',
    mode: 'cors',
    data: postData,
  })
}

export async function submitGoogleLogin({ socialToken, next }: Query) {
  return await getSocialLoginData(
    'google-web',
    {
      name: 'credential',
      value: socialToken,
    },
    next,
  )
}

// tslint:disable-next-line: no-identical-functions
export async function submitFacebookLogin({ socialToken, next }: Query) {
  return await getSocialLoginData(
    'facebook-web',
    {
      name: 'accessToken',
      value: socialToken,
    },
    next,
  )
}
